import { notification } from "antd";
import { IBuxtonDeck } from "../Models/IBuxtonDeck";
import { DataBucketTypeEnum } from "../Enums/DataBucketTypeEnum";

// const a = {a: 1};
// console.log("TEST", a);
// setTimeout(() => {
//   a.a = 2;
// }, 100);

export class BuxtonDeck implements IBuxtonDeck {
  declare deck;
  private _overlayProps;
  private _overlay;

  constructor() {
      this._overlay = null;
      this._overlayProps = [];
      this.deck = (window as any).deck;
  }

  redraw(): void {
      if (this._overlay && this._overlay._deck) {
          this._overlay._deck.redraw(true);
      } else {
          //This console.log is necessary to prevent the error from being thrown in the console
          console.log("Attempted to redraw but _overlay or _deck is not initialized.");
      }
      
  }

  getCanvas(): HTMLCanvasElement {
      return this._overlay._deck.canvas;
  }

  setPropsOnOverlay = (): void => {
      this._overlay?.setProps({
          layers: [...this._overlayProps],
          glOptions: {
              preserveDrawingBuffer: true,
          },
          layerFilter: ({ layer, viewport }) => {
              if (
                  viewport.zoom > 9
          && !layer.id.includes("type-" + DataBucketTypeEnum.HOUSEHOLD_ANALYSIS)
          && !layer.id.includes("deck-gps-")
          && layer.parent instanceof this.deck.HeatmapLayer
              ) {
                  notification.open({
                      type: "warning",
                      message: "Zoom out to level 10 to view this layer.",
                      duration: null, // user must close
                  });
                  return false;
              } else if (
                  viewport.zoom > 11
          && layer.id.includes("type-" + DataBucketTypeEnum.HOUSEHOLD_ANALYSIS)
          && layer.parent instanceof this.deck.HeatmapLayer
              ) {
                  notification.open({
                      type: "warning",
                      message: "Zoom out to level 10 to view this layer.",
                      duration: null, // user must close
                  });
                  return false;
              }
              return true;
          },
      });
  };

  /**
   * Add layer to deck.gl overlay instance
   * @param {this.deck.ScatterplotLayer | this.deck.HeatmapLayer} propToAdd - deck.gl layer to add
   * @param {google.maps.Map} map - instance of google map to add layer to
   */

  addProp = (propToAdd, map): void => {
      //add overlay and set map when props are added if it is not set
      if (!this._overlay) {
          this._overlay = new this.deck.GoogleMapsOverlay({});
          this._overlay.setMap(map);
      }

      //always put heatmap layer on bottom
      // if (propToAdd.id.startsWith(scout.config.deckHeatmapLayerId)) {
      //     this._overlayProps.unshift(propToAdd);
      // } else {
      //     this._overlayProps.push(propToAdd);
      // }

      this._overlayProps.push(propToAdd);
      this.setPropsOnOverlay();
  };

  /**
   * Clears all layers from deck.gl overlay instance
   */
  clearProps = (): void => {
      this._overlayProps = [];
      this.setPropsOnOverlay();
      this.destroyWebGlContext();
  };

  /**
   * Update layer already rendered in deck.gl overlay instance
   * @param {this.deck.ScatterplotLayer | this.deck.HeatmapLayer} propToUpdate - new deck.gl layer with same id as current layer
   */
  updateProp = (propToUpdate): void => {
      for (let i = 0; i < this._overlayProps.length; i++) {
          if (this._overlayProps[i].id === propToUpdate.id) {
              this._overlayProps.splice(i, 1, propToUpdate);
              this.setPropsOnOverlay();
          }
      }
  };

  /**
   * Get layer if it already exists.
   * @param {this.deck.ScatterplotLayer | this.deck.HeatmapLayer | this.deck.PolygonLayer } propToCheck - new deck.gl layer with same id as current layer
   */
  getProp = (propToCheck): boolean => {
      for (const prop of this._overlayProps) {
          if (prop.id === propToCheck.id) {
              return true;
          }
      }

      return false;
  };

  /**
   * Remove specific layer from deck.gl overlay instance
   * @param {this.deck.ScatterplotLayer | this.deck.HeatmapLayer} propToRemove - deck.gl layer to remove
   */
  removeProp = (propToRemove): void => {
      for (let i = 0; i < this._overlayProps.length; i++) {
          if (this._overlayProps[i].id === propToRemove.id) {
              this._overlayProps.splice(i, 1);
              this.setPropsOnOverlay();
          }
      }

      //destroy WebGL context if all props have been removed
      if (this._overlayProps.length === 0) {
          this.destroyWebGlContext();
      }
  };

  destroyWebGlContext = (): void => {
      if (this._overlay) {
          this._overlay?.finalize();
          this._overlay = null;
      } else {
          //This console.log is necessary to prevent the error from being thrown in the console
          console.log("Attempted to finalize _overlay but it is already null.");
      }
  };
}
